import { Search } from "lucide-react";

import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useIsMobile } from "@/hooks/use-mobile";

import { StockOpnameDesktopTable } from "./stock-opname-desktop-table";
import { StockOpnameMobileList } from "./stock-opname-mobile-list";

import type { StockOpname } from "./types";

interface Props {
  opnames: StockOpname[];
  searchQuery: string;
  onSearchQueryChange: (value: string) => void;
  statusFilter: string;
  onStatusFilterChange: (value: string) => void;
  onOpenOpname: (opname: StockOpname) => void;
  onCancelRequest: (opname: StockOpname) => void;
  isRawMaterial: boolean;
}

export function StockOpnameTableCard({
  opnames,
  searchQuery,
  onSearchQueryChange,
  statusFilter,
  onStatusFilterChange,
  onOpenOpname,
  onCancelRequest,
  isRawMaterial,
}: Props) {
  const isMobile = useIsMobile();
  const rowsProps = { rows: opnames, onOpenOpname, onCancelRequest };

  return (
    <Card className="shadow-xs">
      <CardHeader className="pb-3">
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
          <div>
            <CardTitle className="text-base font-semibold">
              Daftar Sesi Opname {isRawMaterial ? "Bahan Baku" : "Produk"}
            </CardTitle>
            <CardDescription className="text-xs">
              Semua catatan sesi penghitungan fisik stok{" "}
              {isRawMaterial ? "bahan baku di toko & bar" : "produk siap jual"}.
            </CardDescription>
          </div>

          {/* Filter controls */}
          <div className="flex flex-wrap items-center gap-2">
            <div className="relative w-full sm:w-64">
              <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground" />
              <Input
                value={searchQuery}
                onChange={(e) => onSearchQueryChange(e.target.value)}
                placeholder="Cari kode / petugas / catatan..."
                className="h-9 pl-8 text-xs"
              />
            </div>

            <Select value={statusFilter} onValueChange={onStatusFilterChange}>
              <SelectTrigger className="h-9 w-full sm:w-[140px] text-xs">
                <SelectValue placeholder="Status" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="all">Semua Status</SelectItem>
                <SelectItem value="draft">Draft / Berjalan</SelectItem>
                <SelectItem value="completed">Selesai</SelectItem>
                <SelectItem value="cancelled">Dibatalkan</SelectItem>
              </SelectContent>
            </Select>
          </div>
        </div>
      </CardHeader>

      <CardContent className="p-0">
        {isMobile ? (
          <StockOpnameMobileList {...rowsProps} />
        ) : (
          <StockOpnameDesktopTable {...rowsProps} />
        )}
      </CardContent>
    </Card>
  );
}
